import React from 'react';
import '../template-file-css/document-file-template.css';


export const NHBC_DiagnosticAssessment = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NHBC_DiagnosticAssessment' className='file-pdf-document'>

            <div className='file-template'>

                <h4>Informant:</h4>
                <p className='w-750'>
                    <span className='eleHeader'>Chief Concern or Complaints:</span>
                </p>
                <p className='w-750'>
                    <span className='small'>(Main behavioral problem, issue, condition, or situation)</span>
                    <textarea name="txtChiefConcern" id="txtChiefConcern" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>History of Present Illness:</span>
                </p>
                <p className='w-750'>
                    <span className='small'>(Age, race, gender, onset, duration, frequency
                        of symptoms, previous episodes, stressors, sleep, mood, energy, weight,
                        appetite, psychotropic medications, psychiatric hospitalizations, etc.)
                    </span>
                    <textarea name="txtPresentIllness" id="txtPresentIllness" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Developmental History:</span>
                </p>
                <p className='w-750'>
                    <span className='small'>(Birth history, developmental delays, school
                        adjustment, abuse and neglect history, etc.)
                    </span>
                    <textarea name="txtDevelopmentalHistory" id="txtDevelopmentalHistory" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Medical Issues:</span>
                </p>
                <p className='w-750'>
                    <span className='small'>(Medications, allergies, acute/chronic conditions,
                        history of meds/illness, etc.)
                    </span>
                    <textarea name="txtMedicalIssues" id="txtMedicalIssues" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Education:</span>
                </p>
                <p className='w-750'>
                    <span className='small'>(Grade in school, retentions, promotions, behavior, grades,
                        learning problems, etc.)
                    </span>
                    <textarea name="txtEducation" id="txtEducation" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Family History:</span>
                </p>
                <p className='w-750'>
                    <span className='small'>(Psychiatric, mental health, medical, substance use,
                        traumas and losses.)
                    </span>
                    <textarea name="txtFamilyHistory" id="txtFamilyHistory" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Family Supports, Current Living Arrangements, and Socialization:</span>
                </p>
                <p className='w-750'>
                    <span className='small'>(Birthplace..childrearing, family of origin and custody issues, foster
                        care/residential placement, marriage, housing, employment, hobbies
                        and interests, etc.)
                    </span>
                    <textarea name="txtFamilySupports" id="txtFamilySupports" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Alcohol/Substance Abuse/Use History:</span>
                </p>
                <p className='w-750'>
                    <span className='small'>(Name of substance(s), age at
                        first use, frequency, amount, when last used, etc.)
                    </span>
                    <textarea name="txtSubstanceAbuse" id="txtSubstanceAbuse" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Legal:</span>
                </p>
                <p className='w-750'>
                    <span className='small'>(Current charges, probation status/officer, pending charges, etc.)
                    </span>
                    <textarea name="txtPendingCharges" id="txtPendingCharges" className='add-only'></textarea>
                </p>
                <h3>Vital Signs:</h3>
                <table>
                    <tr>
                        <td className='w-100'>
                            <span className='eleHeader'>Hgt</span>
                            <input type="text" name="txtHgt" id="txtHgt" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Wgt</span>
                            <input type="text" name="txtWgt" id="txtWgt" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Pulse</span>
                            <input type="text" name="txtPulse" id="txtPulse" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Resp</span>
                            <input type="text" name="txtResp" id="txtResp" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>B/P</span>
                            <input type="text" name="txtBP" id="txtBP" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Temp</span>
                            <input type="text" name="txtTemp" id="txtTemp" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Labs</span>
                            <input type="text" name="txtLabs" id="txtLabs" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Appearance</span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" name="cbWellGroomed" id="cbWellGroomed" className='add-only' value="Well Groomed" />
                            Well Groomed
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbBizarre" id="cbBizarre" className='add-only' value="Bizarre" />
                            Bizarre
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbObese" id="cbObese" className='add-only' value="Obese/Thin" />
                            Obese/Thin
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbOdorous" id="cbOdorous" className='add-only' value="Well Odorous" />
                            Odorous
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbDisheveled" id="cbDisheveled" className='add-only' value="Disheveled" />
                            Disheveled
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" name="cbInappropriate" id="cbInappropriate" className='add-only' value="Inappropriate" />
                            Inappropriate
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbSeductive" id="cbSeductive" className='add-only' value="Seductive" />
                            Seductive
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbNormativeAge" id="cbNormativeAge" className='add-only' value="Normative Age" />
                            Normative Age
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbOlderThanAge" id="cbOlderThanAge" className='add-only' value=" Older Than Age" />
                            Older Than Age
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbYoungerThanAge" id="cbYoungerThanAge" className='add-only' value="Younger Than Age" />
                            Younger Than Age
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments" id="txtComments" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Alertness</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="cbAlertnessNormal" id="cbAlertnessNormal" className='add-only' value="Normal" />
                            Normal
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="cbDiminished" id="cbDiminished" className='add-only' value="Diminished" />
                            Diminished
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="cbAlert" id="cbAlert" className='add-only' value="Hyper-Alert" />
                            Hyper-Alert
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments1" id="txtComments1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Attitude</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" name="cbCooperative" id="cbCooperative" className='add-only' value="Cooperative" />
                            Cooperative
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" name="cbSuspicious" id="cbSuspicious" className='add-only' value="Suspicious" />
                            Suspicious
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" name="cbBelligerent" id="cbBelligerent" className='add-only' value="Belligerent" />
                            Belligerent
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" name="cbAttitudeGuarded" id="cbAttitudeGuarded" className='add-only' value="Guarded" />
                            Guarded
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" name="cbUncooperative" id="cbUncooperative" className='add-only' value="Uncooperative" />
                            Uncooperative
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments2" id="txtComments2" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Eye Contact</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" name="cbGood" id="cbGood" className='add-only' value="Good" />
                            Good
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" name="cbFair" id="cbFair" className='add-only' value="Fair" />
                            Fair
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" name="cbPoor" id="cbPoor" className='add-only' value="Poor" />
                            Poor
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" name="cbVariable" id="cbVariable" className='add-only' value="Variable" />
                            Variable
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments3" id="txtComments3" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Motor Activity</span>
                </p>
                <table>
                    <tr>
                        <td className='w-100'>
                            <input type="checkbox" name="cbCalm" id="cbCalm" className='add-only' value="Calm" />
                            Calm
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbHyperactive" id="cbHyperactive" className='add-only' value="Hyperactive" />
                            Hyperactive
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" name="cbTremors" id="cbTremors" className='add-only' value="Tremors/Tics" />
                            Tremors/Tics
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" name="cbPsychomotorRetardation" id="cbPsychomotorRetardation" className='add-only' value="Psychomotor Retardation" />
                            Psychomotor Retardation
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments4" id="txtComments4" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Affect</span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" name="cbAppropriate" id="cbAppropriate" className='add-only' value="Appropriate" />
                            Appropriate
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbSad" id="cbSad" className='add-only' value="Sad" />
                            Sad
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbWorrisome" id="cbWorrisome" className='add-only' value="Worrisome" />
                            Worrisome
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbExpansive" id="cbExpansive" className='add-only' value="Expansive" />
                            Expansive
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbIntense" id="cbIntense" className='add-only' value="Intense" />
                            Intense
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" name="cbBlunted" id="cbBlunted" className='add-only' value="Blunted" />
                            Blunted
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbConstricted" id="cbConstricted" className='add-only' value="Constricted" />
                            Constricted
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbFlat" id="cbFlat" className='add-only' value="Flat" />
                            Flat
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbLabile" id="cbLabile" className='add-only' value="Labile" />
                            Labile
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbApathetic" id="cbApathetic" className='add-only' value="Apathetic" />
                            Apathetic
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments5" id="txtComments5" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Mood</span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" name="cbAngry" id="cbAngry" className='add-only' value="Angry" />
                            Angry
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbAnhedonia" id="cbAnhedonia" className='add-only' value="Anhedonia" />
                            Anhedonia
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbAnxious" id="cbAnxious" className='add-only' value="Anxious" />
                            Anxious
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbApathetic1" id="cbApathetic1" className='add-only' value="Apathetic" />
                            Apathetic
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbContent" id="cbContent" className='add-only' value="Content" />
                            Content
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" name="cbDemanding" id="cbDemanding" className='add-only' value="Demanding" />
                            Demanding
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbDepressive" id="cbDepressive" className='add-only' value="Depressive" />
                            Depressive
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbDysphoric" id="cbDysphoric" className='add-only' value="Dysphoric" />
                            Dysphoric
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbElevated" id="cbElevated" className='add-only' value="Elevated" />
                            Elevated
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbEntitled" id="cbEntitled" className='add-only' value="Entitled" />
                            Entitled
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" name="cbEuphoric" id="cbEuphoric" className='add-only' value="Euphoric" />
                            Euphoric
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbEuthymic" id="cbEuthymic" className='add-only' value="Euthymic" />
                            Euthymic
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbFearful" id="cbFearful" className='add-only' value="Fearful" />
                            Fearful
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbGuarded" id="cbGuarded" className='add-only' value="Guarded" />
                            Guarded
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbGuilt" id="cbGuilt" className='add-only' value="Guilt" />
                            Guilt
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" name="cbNormal" id="cbNormal" className='add-only' value="Normal" />
                            Normal
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbHopeless" id="cbHopeless" className='add-only' value="Hopeless/Helpless" />
                            Hopeless/Helpless
                        </td>
                        <td className='w-300'>
                            <input type="checkbox" name="cbPassiveAggressive" id="cbPassiveAggressive" className='add-only' value="Passive Aggressive" />
                            Passive Aggressive
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbTearful" id="cbTearful" className='add-only' value="Tearful" />
                            Tearful
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments6" id="txtComments6" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Speech</span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" name="cbNormal1" id="cbNormal1" className='add-only' value="Normal" />
                            Normal
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbSoft" id="cbSoft" className='add-only' value="Soft" />
                            Soft
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbSlurred" id="cbSlurred" className='add-only' value="Slurred" />
                            Slurred
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbExcessive" id="cbExcessive" className='add-only' value="Excessive" />
                            Excessive
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbIncoherent" id="cbIncoherent" className='add-only' value="Incoherent" />
                            Incoherent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" name="cbMute" id="cbMute" className='add-only' value="Mute" />
                            Mute
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbDelayed" id="cbDelayed" className='add-only' value="Delayed" />
                            Delayed
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbLoud" id="cbLoud" className='add-only' value="Loud" />
                            Loud
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbPressured" id="cbPressured" className='add-only' value="Pressured" />
                            Pressured
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbPaucity" id="cbPaucity" className='add-only' value="Paucity" />
                            Paucity
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments7" id="txtComments7" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Stream of Thought</span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" name="cbCircumstantial" id="cbCircumstantial" className='add-only' value="Circumstantial" />
                            Circumstantial
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbGoalOriented" id="cbGoalOriented" className='add-only' value="Goal Oriented" />
                            Goal Oriented
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbUnremarkable" id="cbUnremarkable" className='add-only' value="Unremarkable" />
                            Unremarkable
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbConcrete" id="cbConcrete" className='add-only' value="Concrete" />
                            Concrete
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbBlocking" id="cbBlocking" className='add-only' value="Blocking" />
                            Blocking
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" name="cbTangential" id="cbTangential" className='add-only' value="Tangential" />
                            Tangential
                        </td>
                        <td className='w-150'>&nbsp;</td>
                        <td className='w-150'>&nbsp;</td>
                        <td className='w-150'>&nbsp;</td>
                        <td className='w-150'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments8" id="txtComments8" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Associations</span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" name="cbLogical" id="cbLogical" className='add-only' value="Logical" />
                            Logical
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" name="cbIncomprehensible" id="cbIncomprehensible" className='add-only' value="Incomprehensible" />
                            Incomprehensible
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbLoose" id="cbLoose" className='add-only' value="Loose" />
                            Loose
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbVeryLoose" id="cbVeryLoose" className='add-only' value="Very Loose" />
                            Very Loose
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbOccasionallyLoose" id="cbOccasionallyLoose" className='add-only' value="OccasionallyLoose" />
                            Occasionally Loose
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments9" id="txtComments9" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Thought Content</span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" name="cbAlienation" id="cbAlienation" className='add-only' value="Alienation" />
                            Alienation
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbBroadcasting" id="cbBroadcasting" className='add-only' value="Broadcasting" />
                            Broadcasting
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbControl" id="cbControl" className='add-only' value="Control" />
                            Control
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbDelusional" id="cbDelusional" className='add-only' value="Delusional" />
                            Delusional
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbGrandiose" id="cbGrandiose" className='add-only' value="Grandiose" />
                            Grandiose
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" name="cbHyperReligious" id="cbHyperReligious" className='add-only' value="Hyper-Religious" />
                            Hyper-Religious
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbHypersexual" id="cbHypersexual" className='add-only' value="Hypersexual" />
                            Hypersexual
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbInsertion" id="cbInsertion" className='add-only' value="Insertion" />
                            Insertion
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbNonpsychotic" id="cbNonpsychotic" className='add-only' value="Non-psychotic" />
                            Non-psychotic
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbParanoid" id="cbParanoid" className='add-only' value="Paranoid" />
                            Paranoid
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" name="cbReference" id="cbReference" className='add-only' value="Reference" />
                            Reference
                        </td>

                        <td className='w-150'>&nbsp;</td>
                        <td className='w-150'>&nbsp;</td>
                        <td className='w-150'>&nbsp;</td>
                        <td className='w-150'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments10" id="txtComments10" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Self Perception/ Worth</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" name="cbDiminishedWorth" id="cbDiminishedWorth" className='add-only' value="Diminished Worth" />
                            Diminished Worth
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" name="cbRealistic" id="cbRealistic" className='add-only' value="Realistic" />
                            Realistic
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" name="cbIndifferentToFuture" id="cbIndifferentToFuture" className='add-only' value="Indifferent to Future" />
                            Indifferent to Future
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" name="cbUnrealisticallyHigh" id="cbUnrealisticallyHigh" className='add-only' value="Unrealistically High" />
                            Unrealistically High
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" name="cbUnrealisticallyLow" id="cbUnrealisticallyLow" className='add-only' value="UnrealisticallyLow" />
                            Unrealistically Low
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments11" id="txtComments11" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Safety</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="cbSuicidal" id="cbSuicidal" className='add-only' value="Suicidal" />
                            Suicidal
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="cbHomicidal" id="cbHomicidal" className='add-only' value="Homicidal" />
                            Homicidal
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="cbIntent" id="cbIntent" className='add-only' value="Intent" />
                            With Plans/Intent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="cbIntent1" id="cbIntent1" className='add-only' value="Intent" />
                            No Plans/Intent
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="cbAssaultive" id="cbAssaultive" className='add-only' value="Assaultive" />
                            Assaultive
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="cbThoughtsOfHarm" id="cbThoughtsOfHarm" className='add-only' value="No Thoughts of Harm" />
                            No Thoughts of Harm
                        </td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="cbDisplaysLittle" id="cbDisplaysLittle" className='add-only' value="Displays Little or No Content" />
                            Displays Little or No Content
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="cbRefusesToDisclose" id="cbRefusesToDisclose" className='add-only' value="Refuses to Disclose" />
                            Refuses to Disclose
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments12" id="txtComments12" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Perception</span>
                </p>
                <table>
                    <tr>
                        <td className='w-100'>
                            <input type="checkbox" name="cbNormal2" id="cbNormal2" className='add-only' value="Normal" />
                            Normal
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbHallucinations" id="cbHallucinations" className='add-only' value="Hallucinations" />
                            Hallucinations
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbAuditory" id="cbAuditory" className='add-only' value="Auditory" />
                            Auditory
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbVisual" id="cbVisual" className='add-only' value="Visual" />
                            Visual
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbOlfactory" id="cbOlfactory" className='add-only' value="Olfactory" />
                            Olfactory
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments13" id="txtComments13" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Orientation</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="cbOriented" id="cbOriented" className='add-only' value="Oriented" />
                            Oriented
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="cbDisoriented" id="cbDisoriented" className='add-only' value="Disoriented" />
                            Disoriented
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments14" id="txtComments14" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Concentration</span>
                </p>
                <table>
                    <tr>
                        <td className='w-100'>
                            <input type="checkbox" name="cbGood1" id="cbGood1" className='add-only' value="Good" />
                            Good
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbFair1" id="cbFair1" className='add-only' value="Fair" />
                            Fair
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbPoor1" id="cbPoor1" className='add-only' value="Poor" />
                            Poor
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbVariable1" id="cbVariable1" className='add-only' value="Variable" />
                            Variable
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" name="cbAcceptsRedirection" id="cbAcceptsRedirection" className='add-only' value="Accepts Redirection" />
                            Accepts Redirection
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbEasilyDistracted" id="cbEasilyDistracted" className='add-only' value="Easily Distracted" />
                            Easily Distracted
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments15" id="txtComments15" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Memory</span>
                </p>
                <table>
                    <tr>
                        <td className='w-100'>
                            <input type="checkbox" name="cbIntact" id="cbIntact" className='add-only' value="Intact" />
                            Intact
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbNotIntact" id="cbNotIntact" className='add-only' value="NotIntact" />
                            Not Intact
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbRecent" id="cbRecent" className='add-only' value="Recent" />
                            Recent
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" name="cbIntermediate" id="cbIntermediate" className='add-only' value="Intermediate" />
                            Intermediate
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbRemote" id="cbRemote" className='add-only' value="Remote" />
                            Remote
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments16" id="txtComments16" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Fund of Knowledge</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="cbGood2" id="cbGood2" className='add-only' value="Good" />
                            Good
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="cbFair2" id="cbFair2" className='add-only' value="Fair" />
                            Fair
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="cbPoor2" id="cbPoor2" className='add-only' value="Poor" />
                            Poor
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments17" id="txtComments17" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Insight</span>
                </p>
                <table>
                    <tr>
                        <td className='w-100'>
                            <input type="checkbox" name="cbGood3" id="cbGood3" className='add-only' value="Good" />
                            Good
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbFair3" id="cbFair3" className='add-only' value="Fair" />
                            Fair
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbPoor3" id="cbPoor3" className='add-only' value="Poor" />
                            Poor
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbNone" id="cbNone" className='add-only' value="None" />
                            None
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments18" id="txtComments18" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Judgment</span>
                </p>
                <table>
                    <tr>
                        <td className='w-100'>
                            <input type="checkbox" name="cbGood4" id="cbGood4" className='add-only' value="Good" />
                            Good
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbFair4" id="cbFair4" className='add-only' value="Fair" />
                            Fair
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbPoor4" id="cbPoor4" className='add-only' value="Poor" />
                            Poor
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" name="cbPoorButIntact" id="cbPoorButIntact" className='add-only' value="Poor but intact" />
                            Poor but intact
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="cbAtRisk" id="cbAtRisk" className='add-only' value="At Risk From Self/Others" />
                            At Risk From Self/Others
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments19" id="txtComments19" className='add-only'></textarea>
                </p>
                <h3>ICD -10 Codes Assessment</h3>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>ICD-10 Description</span>
                            <input type="text" name="txtDescription" id="txtDescription" className='add-only' placeholder="ICD-10" />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>DSM-V-TR Code:</span>
                            <input type="text" name="txtTRCode" id="txtTRCode" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Diagnosis (Name):</span>
                            <input type="text" name="txtName" id="txtName" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" name="txtDescription1" id="txtDescription1" className='add-only' placeholder="ICD-10" />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtTRCode1" id="txtTRCode1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtName1" id="txtName1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" name="txtDescription2" id="txtDescription2" className='add-only' placeholder="ICD-10" />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtTRCode2" id="txtTRCode2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtName2" id="txtName2" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Assessment/Formulation:</span>
                </p>
                <p className='w-750'>
                    <span className='small'>(Strengths, Assets, Needs, Problems,
                        Liabilities)
                    </span>
                    <textarea name="txtStrengths" id="txtStrengths" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Plan for Work Up and Treatment:</span>
                </p>
                <p className='w-750'>
                    <span className='small'>(Rx s, Services, Drug Screens, Standing
                        Orders, etc.)
                    </span>
                    <textarea name="txtDrugScreens" id="txtDrugScreens" className='add-only'></textarea>
                </p>

            </div>
        </form>

    )
} 
